import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const CODE = 'line-item/member-discount';

/**
 * Renders the -100% member discount line in the customer breakdown so it
 * reads as a clean "Member discount (Ottawa–Rideau Lakes Membership)" row
 * instead of falling through to the LineItemUnknownItemsMaybe default.
 */
const LineItemMemberDiscountMaybe = props => {
  const { lineItems, intl, isProvider } = props;
  const side = isProvider ? 'provider' : 'customer';
  const discountLine = lineItems.find(
    item =>
      item.code === CODE &&
      !item.reversal &&
      // member-discount is customer-only — guard against a provider view
      // accidentally rendering the customer's credit.
      (Array.isArray(item.includeFor) ? item.includeFor.includes(side) : true)
  );
  if (!discountLine) return null;

  const formattedTotal = formatMoney(intl, discountLine.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        Member discount · Ottawa–Rideau Lakes Membership (−100%)
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

LineItemMemberDiscountMaybe.propTypes = {
  intl: intlShape,
};

LineItemMemberDiscountMaybe.CODE = CODE;

export default LineItemMemberDiscountMaybe;
